module.exports = __webpack_public_path__ + "static/media/Text Grey.2d7c6cd5.svg";